import { UrlSchema } from '@common/hooks/useUrlState';
import { QueryState } from '@common/types/queryState';
import { SortingState } from '@tanstack/react-table';

const safeJsonParse = <T>(value: string | null, fallback: T): T => {
    try {
        return value ? JSON.parse(value) : fallback;
    } catch {
        return fallback;
    }
};

export const GlobalQuerySchema: UrlSchema<QueryState> = {
    search: (v) => v ?? '',
    pageIndex: (v) => Number(v) || 0,
    pageSize: (v) => Number(v) || 10,
    sorting: (v) => safeJsonParse<SortingState>(v, []),
    facets: (v) => safeJsonParse(v, {}),
    ranges: (v) => safeJsonParse(v, {}),
    groupField: (v) => v ?? undefined,
    custom: (v) => safeJsonParse(v, undefined),
};
